// /*
//  * Copyright 2022, Corning Optical Communications
//  * All Rights Reserved.
//  */

//This fuction will remove the all null, undefined, and empty params from query string
export const sanitizeQueryParams = (queryString: any) => {
  const searchParams = Object.fromEntries(new URLSearchParams(queryString));
  const filteredParams = Object.fromEntries(
    Object.entries(searchParams).filter(([_, value]) => value !== "" && value !== "null" && value && value !== "undefined")
  );
  return new URLSearchParams(filteredParams).toString();
};

export const toTimespanRangeMs = (msToSubtract: number) => {
  const currentEpochMilliseconds = Date.now();
  const from = currentEpochMilliseconds - msToSubtract;
  return { from: from.valueOf().toString(), to: currentEpochMilliseconds.toString() };
};

export function encodeParam(input: string): string {
  if (!input) return input;
  return input
    .replace(/%/g, "_PERCENT_")
    .replace(/{/g, "_LCB_")
    .replace(/}/g, "_RCB_")
    .replace(/\(/g, "_LPAREN_")
    .replace(/\)/g, "_RPAREN_")
    .replace(/\[/g, "_LSB_")
    .replace(/\]/g, "_RSB_")
    .replace(/;/g, "_SemiColon_")
    .replace(/'/g, "_SingleQ_")
    .replace(/ /g, "_Space_")
    .replace(/"/g, "_DoubleQ_");
}

export function decodeParam(input: string): string {
  if (!input) return input;
  return input
    .replace(/_PERCENT_/g, "%")
    .replace(/_LCB_/g, "{")
    .replace(/_RCB_/g, "}")
    .replace(/_LPAREN_/g, "(")
    .replace(/_RPAREN_/g, ")")
    .replace(/_LSB_/g, "[")
    .replace(/_RSB_/g, "]")
    .replace(/_SemiColon_/g, ";")
    .replace(/_SingleQ_/g, "'")
    .replace(/_Space_/g, " ")
    .replace(/_DoubleQ_/g, "\"");
}